import { Form, Modal } from "react-bootstrap";
import { callWrite, UPDATE_USER_SETTINGS } from "../../amplify/appsync/write";
import { TrackboardColumn } from "../../amplify/appsync/query";


interface FavoriteColumnSelectModalProps {
    show: boolean;
    setShow: any;
    allColumns: any[];
    columns: any[];
    setColumns: any;
    saveKey: string;
    zone?: string;
    persistColumns?: (zone: string | undefined, cols: TrackboardColumn[]) => Promise<Record<string, TrackboardColumn[]> | TrackboardColumn[]>;
}


export const FavoriteColumnSelectModal = (props: FavoriteColumnSelectModalProps) => {

    const handleClose = () => {
        props.setShow(false);
    };

    const isChecked = (id: string) => {
        for (let col of props.columns) {
            if (col.id === id) {
                return true;
            }
        }
        return false;
    }

    const persistSelection = async (payload: Record<string, TrackboardColumn[]> | TrackboardColumn[]) => {
        try {
            await callWrite({
                operation: UPDATE_USER_SETTINGS,
                settings: {
                    [props.saveKey]: payload,
                }
            });
        } catch (err) {
            console.error("Failed to update trackboard columns", err);
        }
    };

    const handleCheck = async (id: string) => {
        if (isChecked(id)) {
            // Was previously shown, now hide it
            const newCols: TrackboardColumn[] = [];
            const newAllCols: any[] = [];
            for (let col of props.columns) {
                if (col.id !== id) {
                    newCols.push({
                        id: col.id,
                        show: true,
                    });
                    newAllCols.push({
                        ...col,
                        show: true,
                    });
                }
            }
            props.setColumns([...newAllCols]);
            try {
                const payload = props.persistColumns
                    ? await props.persistColumns(props.zone, newCols)
                    : newCols;
                await persistSelection(payload);
            } catch (err) {
                console.error("Failed to update trackboard columns", err);
            }
        } else {
            // Previously hidden, now show
            const newCols: TrackboardColumn[] = [];
            const newAllCols: any[] = [];
            const visibleSet = new Set(props.columns.map((col: any) => col.id));
            visibleSet.add(id);

            for (let col of props.allColumns) {
                if (visibleSet.has(col.id)) {
                    newCols.push({
                        id: col.id,
                        show: true,
                    });
                    newAllCols.push({
                        ...col,
                        show: true,
                    });
                    visibleSet.delete(col.id);
                    if (visibleSet.size === 0) {
                        break;
                    }
                }
            }

            props.setColumns([...newAllCols]);
            try {
                const payload = props.persistColumns
                    ? await props.persistColumns(props.zone, newCols)
                    : newCols;
                await persistSelection(payload);
            } catch (err) {
                console.error("Failed to update trackboard columns", err);
            }
        }
    }

    return (
        <Modal show={props.show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Select Columns</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    props.allColumns.filter(col => col.name !== "").map(col => (
                        <Form.Check
                            key={col.name}
                            type='checkbox'
                        >
                            <Form.Check.Input id={`col-select-${col.name}`} type="checkbox" 
                                checked={isChecked(col.id)} onChange={() => handleCheck(col.id)} />
                            <Form.Check.Label htmlFor={`col-select-${col.name}`}>{col.name}</Form.Check.Label>
                        </Form.Check>
                    ))
                }
            </Modal.Body>
        </Modal>
    )
};
